import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/products/$category/")({
  beforeLoad: ({ params }) => {
    if (params.category === "web-hosting") {
      throw redirect({ to: "/products/web-hosting/shared-hosting" });
    }
    throw redirect({ to: "/products/web-hosting/shared-hosting" });
  },
});
